import React from "react";
import { Box, Typography, Button, useTheme, alpha } from "@mui/material";

interface JoinRequestsToastProps {
  compact?: boolean;
  count: number;
  onViewRequests: () => void;
}

const JoinRequestsToast: React.FC<JoinRequestsToastProps> = ({
  count,
  compact = false,
  onViewRequests,
}) => {
  const theme = useTheme();

  if (count === 0) return null;

  return (
    <Box
      sx={{
        mt: compact ? 1 : 2,
        p: compact ? 1 : 2,
        borderRadius: 2,
        bgcolor: alpha(theme.palette.error.main, 0.08),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flex: 1 }}>
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            bgcolor: theme.palette.error.main,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{
              color: theme.palette.common.white,
              fontSize: (theme) => theme.typography.body2.fontSize,
              fontWeight: 600,
              lineHeight: 1,
            }}
          >
            i
          </Typography>
        </Box>
        <Typography
          sx={{
            color: theme.palette.error.main,
            fontSize: (theme) => theme.typography.body2.fontSize,
            fontWeight: 500,
          }}
        >
          You have {count} join {count === 1 ? "request" : "requests"}
        </Typography>
      </Box>
      <Button
        size="small"
        onClick={onViewRequests}
        sx={{
          textTransform: "none",
          fontWeight: 500,
          color: theme.palette.error.main,
          minWidth: "auto",
          px: 1.5,
          "&:hover": {
            bgcolor: alpha(theme.palette.error.main, 0.08),
          },
        }}
      >
        View Requests
      </Button>
    </Box>
  );
};

export default JoinRequestsToast;
